// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Funnel+Sans:wght@300..800&family=Merriweather+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	line-height: 1.5;
}

h1,
h2,
h3,
h4,
h5,
figure,
p,
ol,
ul,
body {
	margin: 0;
}

ol[role="list"],
ul[role="list"] {
	list-style: none;
	padding-inline: 0;
}

h1,
h2,
h3,
h4,
h5 {
	font-size: inherit;
	font-weight: inherit;
}

img {
	display: block;
	max-inline-size: 100%;
}
* {
	font-family: "Merriweather Sans", sans-serif;
	font-weight: 350;
}

body {
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	overflow: hidden;
}

#content {
	background-color: #ffffff;
	flex-grow: 1;
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding: 20px;
	gap: 30px;
	align-items: center;
	flex-direction: column;
}

.table {
	display: grid;
	grid-template-columns: 1fr 1fr 2fr;
	grid-template-rows: 50px 1fr;
	width: 100%;
	max-width: 1500px;
	flex-grow: 1;
}

h1 {
	text-align: center;
	font-size: 1.3rem;
	font-weight: 600;
	margin: 5px;
}

#lv1List,
#lv2List,
#lv3List {
	background-color: #d5c28b;
	padding: 3px;
	margin: 5px;
	border-radius: 5px;
	overflow-y: scroll;
	max-height: 80vh;
}

/* From https://codepen.io/stephenpaton-tech/full/JjRvGmY */
/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
	scrollbar-width: auto;
	scrollbar-color: #c1ad77 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
	width: 16px;
}

*::-webkit-scrollbar-track {
	background: #ffffff;
}

*::-webkit-scrollbar-thumb {
	background-color: #c1ad77;
	border-radius: 10px;
	border: 3px solid #ffffff;
}

header,
footer {
	background-color: #c1ad77;
	padding: 5px;
	width: 100%;
	text-align: center;
}

.lvlTitle {
	font-size: 1.2rem;
	font-weight: bold;
	text-align: center;
	padding: 5px;
	font-weight: 700;
}

.listing {
	padding: 7px;
	margin: 5px;
	background-color: #fff8e1;
	border: solid 2px black;
	border-radius: 5px;
}

.mainInfo {
	display: flex;
	justify-content: space-between;
}

.extraInfo {
	margin-top: 5px;
	padding-top: 5px;
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.extraInfo > div {
	margin-right: 15px;
	flex-grow: 1;
	border: 1px solid black;
	background-color: white;
	opacity: 0.9;
	max-width: 500px;
	padding: 2px;
	font-size: 0.8em;
}

.extraInfo > p {
	opacity: 0.9;
	padding: 2px;
	border-radius: 5px;
	font-size: 0.8em;
}

.index {
	margin-left: 10px;
	font-size: 0.7rem;
	display: flex;
	align-items: center;
}

.addListing {
	padding: 5px;
	margin: 5px;
	border: dotted 4px #93b93b;
	border-radius: 10px;
	text-align: center;
	cursor: pointer;
	background-color: #c2ec8b;
}

.description {
	font-size: 0.9rem;
}

.icons {
	visibility: hidden;
	display: flex;
	gap: 10px;
	margin-left: auto;
}

.listing:hover .icons {
	visibility: visible;
	cursor: pointer;
}

#basicMenu,
#advMenu {
	padding: 30px;
}

dialog > h2 {
	font-weight: 500;
	font-size: 1.1rem;
	text-align: center;
	background-color: #c1ad77;
}

#basicMenuForm,
#advMenuForm {
	display: grid;
	grid-template-columns: 1fr 2fr;
	gap: 10px;
	padding: 10px;
}

/*and cancel form*/
#basicSubmit,
#basicEdit,
#advSubmit,
#advEdit {
	grid-column: span 2;
	padding: 5px 20px;
	background-color: #c2ec8b;
	border: solid 4px #93b93b;
	border-radius: 10px;
}

#basicCancel,
#advCancel {
	grid-column: span 2;
	padding: 3px 20px;
	font-size: 0.9em;
	border-radius: 8px;
}

.index {
	background-color: #f8de9b;
	border: 4px solid #c2ab6d;
	border-radius: 3px;
	cursor: pointer;
}

.selected {
	background-color: #eadbab;
}

.done {
	text-decoration: line-through;
}

.notStarted {
	background-color: #6fb0d6;
	border: 3px solid rgb(59, 111, 206);
}

.inProgress {
	background-color: rgb(255, 175, 208);
	border: 3px solid rgb(201, 70, 114);
}

.draftCompleted {
	background-color: rgb(238, 174, 100);
	border: 3px solid rgb(148, 100, 61);
}

.reviewed {
	background-color: rgb(255, 148, 255);
	border: 3px solid rgb(131, 61, 148);
}

.sentBack {
	background-color: rgb(255, 92, 92);
	border: 3px solid rgb(121, 36, 36);
}

.approved {
	background-color: rgb(156, 218, 106);
	border: 3px solid rgb(66, 145, 42);
}

.completed {
	background-color: rgb(255, 223, 83);
	border: 3px solid rgb(207, 150, 27);
}

.settings {
	background-color: #e7d39a;
	padding: 15px 40px;
	text-align: center;
	display: grid;
	grid-template-columns: 3fr 1fr;
	gap: 12px;
	border-radius: 10px;
}

.settings > h3 {
	grid-column: span 2;
	background-color: #c1ad77;
	border-radius: 5px;
	padding: 5px;
}

.settings > input,
.settings > button {
	padding: 5px;
	border: 2px solid black;
	border-radius: 5px;
}

#refresh {
	grid-column: span 2;
	cursor: pointer;
}

.deleted {
	border: 2px solid rgb(146, 31, 31);
	opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB;;AAEA;;;;;;;;;;CAUC,SAAS;AACV;;AAEA;;CAEC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;;;;CAKC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;AAGA;CACC,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,WAAW;CACX,mBAAmB;CACnB,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,WAAW;CACX,aAAa;CACb,8BAA8B;CAC9B,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,4BAA4B;CAC5B,WAAW;CACX,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;;;CAGC,yBAAyB;CACzB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA,2DAA2D;AAC3D,8BAA8B;AAC9B,YAAY;AACZ;CACC,qBAAqB;CACrB,gCAAgC;AACjC;;AAEA,6BAA6B;AAC7B;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,uBAAuB;CACvB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,0BAA0B;CAC1B,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;;CAEC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,aAAa;AACd;;AAEA,kBAAkB;AAClB;;;;CAIC,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,mCAAmC;AACpC;;AAEA;CACC,oCAAoC;CACpC,mCAAmC;AACpC;;AAEA;CACC,oCAAoC;CACpC,mCAAmC;AACpC;;AAEA;CACC,oCAAoC;CACpC,mCAAmC;AACpC;;AAEA;CACC,kCAAkC;CAClC,kCAAkC;AACnC;;AAEA;CACC,oCAAoC;CACpC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;CACnC,mCAAmC;AACpC;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;AACb;;AAEA;;CAEC,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kCAAkC;CAClC,YAAY;AACb","sourcesContent":[":root {\n\tline-height: 1.5;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nfigure,\np,\nol,\nul,\nbody {\n\tmargin: 0;\n}\n\nol[role=\"list\"],\nul[role=\"list\"] {\n\tlist-style: none;\n\tpadding-inline: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n\tfont-size: inherit;\n\tfont-weight: inherit;\n}\n\nimg {\n\tdisplay: block;\n\tmax-inline-size: 100%;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Funnel+Sans:wght@300..800&family=Merriweather+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\n* {\n\tfont-family: \"Merriweather Sans\", sans-serif;\n\tfont-weight: 350;\n}\n\nbody {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100vh;\n\twidth: 100%;\n\talign-items: center;\n\tjustify-content: space-between;\n\toverflow: hidden;\n}\n\n#content {\n\tbackground-color: #ffffff;\n\tflex-grow: 1;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px;\n\tgap: 30px;\n\talign-items: center;\n\tflex-direction: column;\n}\n\n.table {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr 2fr;\n\tgrid-template-rows: 50px 1fr;\n\twidth: 100%;\n\tmax-width: 1500px;\n\tflex-grow: 1;\n}\n\nh1 {\n\ttext-align: center;\n\tfont-size: 1.3rem;\n\tfont-weight: 600;\n\tmargin: 5px;\n}\n\n#lv1List,\n#lv2List,\n#lv3List {\n\tbackground-color: #d5c28b;\n\tpadding: 3px;\n\tmargin: 5px;\n\tborder-radius: 5px;\n\toverflow-y: scroll;\n\tmax-height: 80vh;\n}\n\n/* From https://codepen.io/stephenpaton-tech/full/JjRvGmY */\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n\tscrollbar-width: auto;\n\tscrollbar-color: #c1ad77 #ffffff;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n\twidth: 16px;\n}\n\n*::-webkit-scrollbar-track {\n\tbackground: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n\tbackground-color: #c1ad77;\n\tborder-radius: 10px;\n\tborder: 3px solid #ffffff;\n}\n\nheader,\nfooter {\n\tbackground-color: #c1ad77;\n\tpadding: 5px;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.lvlTitle {\n\tfont-size: 1.2rem;\n\tfont-weight: bold;\n\ttext-align: center;\n\tpadding: 5px;\n\tfont-weight: 700;\n}\n\n.listing {\n\tpadding: 7px;\n\tmargin: 5px;\n\tbackground-color: #fff8e1;\n\tborder: solid 2px black;\n\tborder-radius: 5px;\n}\n\n.mainInfo {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.extraInfo {\n\tmargin-top: 5px;\n\tpadding-top: 5px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n}\n\n.extraInfo > div {\n\tmargin-right: 15px;\n\tflex-grow: 1;\n\tborder: 1px solid black;\n\tbackground-color: white;\n\topacity: 0.9;\n\tmax-width: 500px;\n\tpadding: 2px;\n\tfont-size: 0.8em;\n}\n\n.extraInfo > p {\n\topacity: 0.9;\n\tpadding: 2px;\n\tborder-radius: 5px;\n\tfont-size: 0.8em;\n}\n\n.index {\n\tmargin-left: 10px;\n\tfont-size: 0.7rem;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.addListing {\n\tpadding: 5px;\n\tmargin: 5px;\n\tborder: dotted 4px #93b93b;\n\tborder-radius: 10px;\n\ttext-align: center;\n\tcursor: pointer;\n\tbackground-color: #c2ec8b;\n}\n\n.description {\n\tfont-size: 0.9rem;\n}\n\n.icons {\n\tvisibility: hidden;\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-left: auto;\n}\n\n.listing:hover .icons {\n\tvisibility: visible;\n\tcursor: pointer;\n}\n\n#basicMenu,\n#advMenu {\n\tpadding: 30px;\n}\n\ndialog > h2 {\n\tfont-weight: 500;\n\tfont-size: 1.1rem;\n\ttext-align: center;\n\tbackground-color: #c1ad77;\n}\n\n#basicMenuForm,\n#advMenuForm {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 2fr;\n\tgap: 10px;\n\tpadding: 10px;\n}\n\n/*and cancel form*/\n#basicSubmit,\n#basicEdit,\n#advSubmit,\n#advEdit {\n\tgrid-column: span 2;\n\tpadding: 5px 20px;\n\tbackground-color: #c2ec8b;\n\tborder: solid 4px #93b93b;\n\tborder-radius: 10px;\n}\n\n#basicCancel,\n#advCancel {\n\tgrid-column: span 2;\n\tpadding: 3px 20px;\n\tfont-size: 0.9em;\n\tborder-radius: 8px;\n}\n\n.index {\n\tbackground-color: #f8de9b;\n\tborder: 4px solid #c2ab6d;\n\tborder-radius: 3px;\n\tcursor: pointer;\n}\n\n.selected {\n\tbackground-color: #eadbab;\n}\n\n.done {\n\ttext-decoration: line-through;\n}\n\n.notStarted {\n\tbackground-color: #6fb0d6;\n\tborder: 3px solid rgb(59, 111, 206);\n}\n\n.inProgress {\n\tbackground-color: rgb(255, 175, 208);\n\tborder: 3px solid rgb(201, 70, 114);\n}\n\n.draftCompleted {\n\tbackground-color: rgb(238, 174, 100);\n\tborder: 3px solid rgb(148, 100, 61);\n}\n\n.reviewed {\n\tbackground-color: rgb(255, 148, 255);\n\tborder: 3px solid rgb(131, 61, 148);\n}\n\n.sentBack {\n\tbackground-color: rgb(255, 92, 92);\n\tborder: 3px solid rgb(121, 36, 36);\n}\n\n.approved {\n\tbackground-color: rgb(156, 218, 106);\n\tborder: 3px solid rgb(66, 145, 42);\n}\n\n.completed {\n\tbackground-color: rgb(255, 223, 83);\n\tborder: 3px solid rgb(207, 150, 27);\n}\n\n.settings {\n\tbackground-color: #e7d39a;\n\tpadding: 15px 40px;\n\ttext-align: center;\n\tdisplay: grid;\n\tgrid-template-columns: 3fr 1fr;\n\tgap: 12px;\n\tborder-radius: 10px;\n}\n\n.settings > h3 {\n\tgrid-column: span 2;\n\tbackground-color: #c1ad77;\n\tborder-radius: 5px;\n\tpadding: 5px;\n}\n\n.settings > input,\n.settings > button {\n\tpadding: 5px;\n\tborder: 2px solid black;\n\tborder-radius: 5px;\n}\n\n#refresh {\n\tgrid-column: span 2;\n\tcursor: pointer;\n}\n\n.deleted {\n\tborder: 2px solid rgb(146, 31, 31);\n\topacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
